/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdChecklistItems202,
  PostApiV1ClassroomdisciplineIdChecklistItems400,
  PostApiV1ClassroomdisciplineIdChecklistItems401,
  PostApiV1ClassroomdisciplineIdChecklistItems404,
  PostApiV1ClassroomdisciplineIdChecklistItemsMutationRequest,
  PostApiV1ClassroomdisciplineIdChecklistItemsMutationResponse,
  PostApiV1ClassroomdisciplineIdChecklistItemsPathParams,
} from "../../types/classPlanningCheckListController/PostApiV1ClassroomdisciplineIdChecklistItems.ts";
import { createClassPlanningChecklistItemRequestViewModelSchema } from "../createClassPlanningChecklistItemRequestViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdChecklistItemsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItemsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdChecklistItems202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItems202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdChecklistItems400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItems400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdChecklistItems401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItems401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdChecklistItems404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItems404>;

export const postApiV1ClassroomdisciplineIdChecklistItemsMutationRequestSchema =
  z.lazy(
    () => createClassPlanningChecklistItemRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItemsMutationRequest>;

export const postApiV1ClassroomdisciplineIdChecklistItemsMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdChecklistItems202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChecklistItemsMutationResponse>;
